import { Box, styled } from "@mui/material";
import Slider from "react-slick";

export const TechPartnersSectionContainer = styled("div")`
  text-align: center;
  padding: 3.542vw;/* 51px */ 
  @media (max-width: 768px) {
    padding: 4vw; 
  }
  @media (max-width: 375px) {
    padding: 3.403vw;/* 49px */ 
  }
`;

export const TechPartnersTitle = styled("span")`
  color: #414042;
  text-align: center;
  font-family: Radikal;
  font-size: 2.625rem;/*42px */
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
  @media (max-width: 375px) {
    font-size: 1.313rem;/*21px */
  }
`;

export const TechPartnersSubtitle = styled("p")`
  color: #414042;
  text-align: center !important;
  font-family: Radikal;
  font-size: 1.125rem;/*18px */
  font-weight: 500;
  margin-bottom: 3vw;
  max-width: 65%;
  padding-top: 2.153vw;/* 31px */ 
  margin-left: auto; 
  margin-right: auto; 
  @media (max-width: 768px) {
    font-size: 1rem;
    max-width: 90%;
  }
  @media (max-width: 378px) {
    font-size: 0.813rem;/*13px */
    max-width: 90%;
  }
`;

export const TechPartnersDesktopGrid = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2vw;
  align-items: center;
  justify-content: center;
  margin-bottom: 2vw;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TechPartnersRow = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3vw;
  width: 100%;
  position: relative;
`;

export const TechPartnersDivider = styled("div")`
  height: 40px;
  width: 1.5px;
  background-color: #000;
`;

export const TechPartnersLogoImage = styled("img")`
  width: 100%;
  max-width: 120px;
  height: auto;
  @media (max-width: 320px) {
    max-width: 80px;
  }
`;

export const TechPartnersMobileSliderContainer = styled("div")`
  position: relative;
  display: none;

  @media (max-width: 768px) {
    padding-top:10px;
    display: block;

    .slick-slide {
      border-right: none;
    }

    .slick-active + .slick-active {
      border-left: 1.5px solid #000;    
    .slick-active:last-child {
      border-right: none;
    }
  }
`;

export const TechPartnersArrowButton = styled("img")`
  width: 4vw;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
`;


 /* PlatformInsights */

 export const PlatformInsightsSectionContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: ${(props) => (props.isDueDiligence ? "flex-start" : "center")};  
  padding: 1vw 4vw;
  gap: 5vw;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    padding: 1vw 6vw;
  }
`;

export const PlatformInsightsLeftContent = styled("div")`
  width: 50%;
  ${(props) =>
    props.isDueDiligence &&
    `
      padding: 6vw 2vw; 
  `}

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const PlatformInsightsRightContent = styled("div")`
  width: 50%;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const PlatformInsightsTitle = styled("h2")`
  font-size: 2.625rem;/*42px */
  font-weight: 600;
  font-family: Montserrat;
  color: #414042;
  margin-bottom: 2.361vw;/*34px */
  @media (max-width: 768px) {
    font-size: 1.313rem;/*21px */

  }
`;

export const PlatformInsightsSubTitle = styled("p")`
  font-family: Radikal;
  font-size: 1.500rem;/*24px */
  color: #1D00C4;
  font-weight: 400;
  margin-bottom: 1vw;
  @media (max-width: 768px) {
    font-size: 1rem;/*16px */
    margin-bottom: 1.063rem;/*17px */

  }
`;

export const PlatformInsightsDescription = styled("p")`
  color: #231F20;
  font-family: Radikal;
  font-size: 1.125rem;/*18px */
  font-weight: 400;
  line-height: 24px;
  @media (max-width: 768px) {
    font-size: 0.813rem;/*13px */
    line-height: 15px;
  }
`;

export const PlatformInsightsRightImageWrapper = styled("img")`
  width: 100%;
  ${'' /* max-width: 450px; */}
  max-width: ${(props) => (props.isDueDiligence ? "55vw" : "450px")}; 
  @media (max-width: 768px) {
    max-width: 350px;
  }
`;


 /* SerivceStatsCard */
 export const ServiceStatsCardsContainer = styled("div")`
  padding: 3vw 5vw 0vw !important;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const ServiceStatsCardsTitle = styled("span")`
  font-size: 2.625rem;/*42px*/ 
  font-family: Montserrat;
  color: #414042;
  text-align: left;
  font-weight: 600;
  @media (max-width: 768px) {
    font-size: 1.313rem; /* 21px */
  }
`;

export const ServiceStatsCardsWrapper = styled("div")`
  display: flex;
  justify-content: flex-start;
  gap: 4vw;
  margin-top:4vw;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin-top:5vw;
    gap: 5vw;
  }
`;

export const ServiceStatsCardsCard = styled("div")`
  width: 32%; /* 404px */
  background: white;
  border-radius: 12px;
  border: 1px solid #D3D7FF;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${'' /* gap: 1vw; */}
  cursor:pointer;
  filter: drop-shadow(7px 7px 10px rgba(219, 219, 219, 0.60));
  transition: background-color 0.3s ease;
  padding-bottom: 4vw;
  &:hover {
    background-color: ${(props) => props.hoverBgColor || "#f0f0f0"};
  }
  &:hover h3 {
    color: white !important;
  }
    &:hover .degree-symbol {
    background-color: white; /* Make degree symbol filled with white */
    color: transparent;  /* Make text invisible as we use the background circle */
    border-radius: 50%;  /* Make it a circle */
  }
  @media (max-width: 768px) {
    width: 60%;
    padding: 5vw 3vw 0vw;
  }
`;

export const ServiceStatsCardsNumber = styled("h3")`
  font-family: Radikal;
  font-size: 6.563rem; /* 105px */
  font-weight: 600;
  padding-top:7.917vw;//112px
  color: ${(props) => props.color || "#000"};
  position: relative; 
  .degree-symbol {
    font-size: 0.2em;
    position: absolute; 
    top: 7vw; 
    left: 100%; 
    transform: translateX(-50%); 
    transition: background-color 0.3s ease; 
    border-radius: 50%; 
    color: transparent; 
    background-color: ${(props) => props.color || "#D3D7FF"}; 
    width: 1.2em; 
    height: 1.2em; 
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 768px) {
    font-size: 3.750rem;/*60px*/ 
    padding-top:3.889vw;//56px
    .degree-symbol {
      top: 3vw; 
    }

  }
  
`;

export const ServiceStatsCardsText = styled("p")`
  font-family: Radikal;
  font-size: 2.063rem; /* 33px */
  font-weight: 500;
  margin: 0;
  flex-grow: 1;
  padding-bottom: 2vw; 
  @media (max-width: 768px) {
    font-size: 1.313rem; /* 21px */
    padding-bottom: 15vw; 

  }
`;

export const ServiceStatsCardsTriangleIcon = styled("img")`
  width: 4vw;
  position: absolute;
  bottom: 0.5vw; 
  left: 50%; 
  transform: translateX(-50%);
  @media (max-width: 768px) {
    width: 7vw;
    margin-bottom: 0.9vw;
  }
`;


 
 /* WhyChooseUs */

 export const WhyChooseUsContainer = styled("div")`
  padding: 3vw 4.5vw 0vw;/*80px */
`;

export const WhyChooseUsRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4vw;

  @media (max-width: 768px) {
    flex-direction: column !important; 
    text-align: center;
  }
`;

export const WhyChooseUsTextWrapper = styled("div")`
  width: 50%;
  text-align: left;
  ${({ reverse }) => reverse && `
    text-align: end;
  `}
  margin-top: ${({ dueDiligence }) => dueDiligence ? '5vw' : ''}; 

  @media (max-width: 768px) {
    width: 100%;
    order: 2;
    text-align: center;

  }
 
`;

export const WhyChooseUsTitle = styled("span")`
  font-size: 2.625rem;/*42px*/
  font-family: Montserrat;
  font-weight: 600;
  color: ${({ dueDiligence }) => dueDiligence ? '#1D00C4' : '#414042'}; 
  @media (max-width: 1280px) {
    font-size: 2rem;
  }
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  @media (max-width: 375px) {
    font-size: 1.313rem;/*21px*/
  }
`;

export const WhyChooseUsSubTitle = styled("p")`
  font-size: ${({ dueDiligence }) => dueDiligence ? '2.625rem' : '1.5rem'}; 
  font-weight: 400;
  ${'' /* color: #1D00C4; */}
  color: ${({ dueDiligence }) => dueDiligence ? '#414042' : '#1D00C4'}; 
  font-family: Radikal;
  margin-top: 2.014vw;/*29px*/
  margin-bottom: 1.528vw;/*22px*/
  @media (max-width: 1280px) {
    font-size: ${({ dueDiligence }) => dueDiligence ? '2rem' : '1rem'}; 
    margin-top: 1.4vw;
    margin-bottom: 1vw;
  }
  @media (max-width: 768px) {
    font-size: ${({ dueDiligence }) => dueDiligence ? '1.6rem' : '1.2rem'}; 
  }
  @media (max-width: 375px) {
    font-size: 1rem;/*16px*/
  }
`;

export const WhyChooseUsDescription = styled("p")`
  font-size: 1.125rem;/*18px*/
  color: #231f20;
  font-family: Radikal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
  @media (max-width: 1280px) {
    font-size: 0.9rem;
  }
  @media (max-width: 768px) {
    font-size: 1rem;/*13px*/
    padding:4vw 8vw;
  }
  @media (max-width: 375px) {
    font-size: 0.9rem;/*13px*/
  }
`;

export const WhyChooseUsImageWrapper = styled("img")`
  width: 40%;
  max-height: 400px; 
  object-fit: contain;
  @media (max-width: 1280px) {
    max-height: 350px; 
  }
  @media (max-width: 768px) {
    width: 70%;
    margin-bottom: 2vw;
    max-height: 250px; 
    order: 1; 
  }
  @media (max-width: 375px) {
    width: 75%;
    max-height: 200px; 
  }
`;


 /* CheckCategories */
 export const CheckCategoriesContainer = styled("div")`
  text-align: center;
  padding: 4.514vw 5.278vw;/*65px 76px*/
  background-color: #D3D7FF;
  @media (max-width: 768px) {
    padding: 6vw 7vw;

  }
  @media (max-width: 375px) {
    padding: 2rem 8vw;/*32px 26px*/
  }
`;

export const CheckCategoriesTitle = styled("span")`
  font-size: 2.250rem;/*36px*/
  font-weight: 400;
  color: #414042;
  font-family: Radikal;
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
  @media (max-width: 375px) {
    font-size: 1.313rem;/*21px*/
  }
`;

export const CheckCategoriesGridContainer = styled("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2vw;
  justify-content: center;
  margin-top: 3.056vw;/*44vw*/

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 4vw;
    margin-top: 5vw;
  }
`;

export const CheckCategoriesCard = styled("div")`
  background: #FFFFFF;
  border-radius: 10px;
  padding-top: 3.889vw;/*56px */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;  
  border:1.5px solid #D3D7FF;
  filter: drop-shadow(7px 7px 10px rgba(219, 219, 219, 0.60));
  transition: transform 0.2s, border 0.3s ease;
  &:hover {
    transform: scale(1.05);
    border: 2px solid #1D00C4;
  }
  @media (max-width: 1280px) {
    padding-top: 2vw;
  }
  @media (max-width: 768px) {
    padding-top: 8vw;/*28px */
  }
  @media (max-width: 375px) {
    padding-top: 5vw;/*28px */
  }

`;
export const CheckCategoriesIconWrapper = styled("div")`
  width: 100%; 
  height: 8vw; 
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    margin-bottom: 2vw; 
  }
`;

export const CheckCategoriesIcon = styled("img")`
  width: 6vw;  
  height: auto;
  object-fit: contain;  
  @media (max-width: 768px) {
    width: 10vw;  
  }
  @media (max-width: 375px) {
    width: 8vw;  
  }
`;

export const CheckCategoriesLabel = styled("p")`
  font-size: 1.313rem;/*21px*/
  font-weight: 400;
  line-height: 24px;
  font-family: Radikal;
  color: #1D00C4;
  text-align: center;  
  margin-top: 0;  
  flex-grow: 1;  
  padding: 1vw 0vw 4vw;/*30px auto 65px*/  
  white-space: pre-line; 
  @media (max-width: 1024){
    font-size: 1rem;/*21px*/
  }
  @media (max-width: 768px) {
    font-size: 3vw;
    line-height: 18px;
    padding: 2vw 0vw 5vw; 

  }
`;


 /* BlogSection */

 export const BlogContainer = styled("div")`
  padding: 3.3vw 9.167vw;/*32px 132px */
  display: flex;
  flex-direction: column;
  background-color: #ECEAEA;
  @media (max-width: 768px) {
    padding: 4vw 8vw;
  }
  @media (max-width: 375px) {
    padding: 4vw 6vw;/*21px 23px */
  }
`;

export const BlogSectionTitle = styled("span")`
    font-family: Radikal;
    font-size: 2.063rem;/*33px*/ 
    font-family: Radikal;
    font-weight: 500;
    color: #414042;
    text-align: left;
  @media (max-width: 768px) {
    font-size: 1.8rem;/*21px*/ 
    text-align: center !important;
  }
  @media (max-width: 375px) {
    font-size: 1.313rem;/*21px*/ 
  }
`;

export const BlogGrid = styled("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2vw;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BlogCard = styled("div")`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2vw;
  cursor: pointer;
  @media (max-width: 768px) {
    padding-top: 4vw;
  }
`;

export const BlogImage = styled("img")`
  ${'' /* width: 100%; */}
  height: 12vw;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    max-height: 55vw; 
  }
`;

export const BlogText = styled("p")`
 color: #231F20;
 font-family: Radikal;
 font-size: 0.938rem;/*15px*/
 font-weight: 400;
 margin-top: 1vw;
  @media (max-width: 768px) {
    margin-top: 3vw;

  }
`;

export const BlogSectionMobileSlider = styled(Slider)`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 90%;
    margin: 0 auto;
  }
`;

export const BlogSectionArrowButton = styled("img")`
  width: 4vw;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
`;

export const BlogSectionArrowWrapper = styled("div")`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4vw;
`;




 /* BlogForm */
export const ModalWrapper = styled("div")`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled("div")`
  background: white;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  ${'' /* padding-bottom:2vw; */}
@media (max-width: 768px) {
  width:80%;
}
`;

export const ModalHeader = styled("div")`
  position: relative;
`;


export const BlueHeader = styled("div")`
  width: 100%;
  height: 50px;
  background-color: #1D00C4;
  position: absolute;
  top: 0;
  left: 0;
  @media (max-width:768)
`;
export const ModalCloseButton = styled("button")`
  background: none;
  border: none;
  font-size: 25px;
  cursor: pointer;
  color: white;
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 10;
`;

export const Form = styled("form")`
  display: flex;
  flex-direction: column;
  width: 80%;
  padding: 3vw 2vw; 
  margin-top: 20px; 
  background: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
  z-index: 10;
  margin-left: auto; 
  margin-right: auto; 
  @media (max-width: 768px) {
    position: relative;
    transform: none;
    top: auto;
    right: auto;
    padding:4vw 5vw 7vw;
  }
`;

export const InputField = styled("input")`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f0f2ff;
`;

export const SubmitButton = styled("button")`
  background-color: #1d00c4;
  color: #fff;
  padding: 0.7rem 3rem;
  font-size: 1.5rem; /* 24px */
  font-weight: 500;
  text-transform: none;
  margin-top: 1rem;
  border: 0.9px solid #1d00c4;
  align-self: center;
  position: relative;
  box-shadow: none;
  color: #FFF;
  text-align: center;
  font-family: Radikal;
  font-size: 1.5rem;/*24px*/
  font-weight: 500;
  margin: 2vw auto;
  border-radius: 18px !important;
  &::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    border-radius: 17px;
    border: 3.5px solid #fff;
  }
  @media (max-width: 768px){
    margin: 4vw auto;
    font-size: 0.75rem;
    padding: 0.7rem 2rem;
 }
  
`;




 /* AboutUs */




 export const AboutUsContainer = styled(Box)`
  background-color: #EDEEFF;
  color: #FFFFFF;
  padding: 5vw 6vw;
  @media (max-width: 768px) {
    padding: 8vw 6vw 14vw;

  }
`;

export const AboutSection = styled("div")`
  margin:2vw auto
  @media (max-width: 768px) {
  margin:5vw auto

  }
`;

export const AboutTitle = styled("h2")`
    color: #000000;
    font-family: Montserrat;
    font-size: 3.188rem;/*51px*/
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    @media (max-width: 1280px) {
        font-size: 2.5rem;
    }
    @media (max-width: 768px) {
        font-size: 1.500rem;/*24px*/

    }

`;
export const AboutDescription = styled("div")`
    color: #000000;
    font-family: Radikal;
    font-size: 1.125rem;/*18px*/
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin:5vw auto;
    @media (max-width: 1280px) {
        font-size: 1rem;
    }
    @media (max-width: 768px) {
        font-size: 0.813rem;/*13px*/
        margin:8vw auto;

    }
`;

export const AboutSubTitle = styled("div")`
    color: #000000;
    font-family: Montserrat;
    font-size: 2.625rem;/*42px*/
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin:4vw auto;
    @media (max-width: 1280px) {
        font-size: 2rem;
    }
    @media (max-width: 768px) {
        font-size: 1.500rem;/*24px*/

    }

`;

export const AboutLetterSection = styled("div")`
    background-color: #D9D9D9;
    padding: 6vw;
    text-align: left;
    @media (max-width: 768px) {
        padding: 8vw;
    }
`;

export const AboutLetterLetterHeading = styled("h3")`
  color: #000;
  font-family: Montserrat;
  font-size: 2.625rem; /* 42px */
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 1vw;
  @media (max-width: 1280px) {
      font-size: 2rem;
    }
  @media (max-width: 768px) {
    font-size: 1.688rem; /* 27px */
    display: block; 
  }
`;

export const AboutLetterHeadingText = styled("span")`
  display: inline;

  @media (max-width: 768px) {
    display: block;
    line-height: 1.3;
  }
`;




/*PrivacyPolicy */


export const PrivacyPolicyContainer = styled('div')`
  padding: 5vw;
  margin: auto;
`;

export const PrivacyPolicySectionTitle = styled('h2')`
  color: #231F20;
  font-family: Radikal;
  font-size: 1.125rem;/*18px */
  font-weight: 900;
  line-height: 24px; /* 133.333% */
  margin: 20px 0;
  @media (max-width: 768px) {
    font-size: 1rem; 
  }
  @media (max-width: 375px) {
    font-size: 0.813rem; /* 13px */
  }
`;

export const PrivacySection = styled("p")`
  color: #231F20;
  font-family: Radikal;
  font-size: 1.125rem ;/*18px */
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 15px;
  position: relative;
  padding-left: ${(props) =>
    props.type === "number" || props.type === "bullet" || props.type === "letter" ? "2.5rem" : "0"};

  font-weight: ${(props) => (props.type === "letter" ? "600" : "400")};

  &::before {
    content: ${(props) =>
      props.type === "number"
        ? `"${props.parentNumber ? props.parentNumber + "." : ""}${props.number}."` /* Numbering */
        : props.type === "bullet"
        ? '"●"' 
        : props.type === "letter"
        ? `"${props.letter || "a"}."` 
        : "none"}; 

    position: ${(props) => (props.type ? "absolute" : "unset")};
    left: ${(props) => (props.type ? "0" : "unset")};
    color: #231F20;
    font-family: Radikal;
    font-size: 1.125rem;/*18px */
    font-weight: ${(props) => (props.type === "letter" ? "700" : "400")}; 
    margin-right: ${(props) => (props.type ? "10px" : "0")};

 
  }
  a {
    color: #3e2f94;
    text-decoration: none;
    font-weight: 600;
    &:hover {
      text-decoration: underline;
    }
  }
  @media (max-width: 768px) {
    font-size: 1rem; 
    padding-left: ${(props) =>
    props.type === "number" || props.type === "bullet" || props.type === "letter" ? "2rem" : "0"};

 
  }
  @media (max-width: 375px) {
    font-size: 0.813rem; /* 13px */
  }
`;



export const PrivacySectionBoldParagraph = styled('p')`
  color: #231F20;
  font-family: Radikal;
  font-size: 1.125rem ;/*18px */
  font-style: normal;
  font-weight: 900;
  line-height: 24px;
  margin-bottom:2vw;
  @media (max-width: 768px) {
    font-size: 0.9rem; 
  }
  @media (max-width: 375px) {
    font-size: 0.813rem; /* 13px */
  }
`;

export const PrivacyPolicyDisclaimerText = styled('p')`
    color: #231F20;
    font-family: Radikal;
    font-size: 1.125rem  ;/*18px */
    font-style: italic;
    font-weight: 500;
    line-height: 24px;
    @media (max-width: 768px) {
    font-size: 1rem; 
  }
  @media (max-width: 375px) {
    font-size: 0.813rem; /* 13px */
  }
`;



/*  Terms & Conditions*/


export const TermsConditionsWrapper = styled("div")`
  padding: 5vw;
  margin: auto;
  @media (max-width: 1280px) {
    padding: 2vw 5vw;
  }
`;

export const TermsConditionsSection = styled("div")`
  margin-bottom: 30px;
`;

export const TermsConditionsSubTitle = styled("h2")`
  color: #231F20;
  font-family: Radikal;
  font-size: 1.125rem;/*18px */
  font-weight: 900;
  line-height: 24px; /* 133.333% */
  margin: 20px 0;
  @media (max-width: 768px) {
    font-size: 1rem; 
  }
  @media (max-width: 375px) {
    font-size: 0.813rem; /* 13px */
  }
  margin-bottom: 10px;
`;

export const TermsConditionsDescription = styled("p")`
  font-family: Radikal;
  font-size: 1rem;/*16px */
  font-weight: 400;  
  line-height: 24px;
  color: #231F20;
  margin: 2vw auto;
  @media (max-width: 768px) {
    font-size: 1rem; 
  }
  @media (max-width: 375px) {
    font-size: 0.813rem; /* 13px */
  }
`;

export const TermsConditionsList = styled("ul")`
  padding-left: 20px;
  font-family: Radikal;
  font-size: 1.125rem;/*18px */
  font-weight: 400;  
  line-height: 24px;
  color: #231F20;
  @media (max-width: 768px) {
    font-size: 1rem; 
  }
  @media (max-width: 375px) {
    font-size: 0.813rem; /* 13px */
  }
`;

export const TermsConditionsListItem = styled("li")`
  margin-bottom: 5px;
`;